import React, { useEffect } from 'react';
import useBreadcrumb from 'src/hooks/useBreadcrumb';
import TitleBar from 'src/components/layout/TitleBar';
import { BellOutlined, DeleteOutlined } from '@ant-design/icons';
import { Table, Button, Popconfirm } from 'antd';
import useAsyncProcesses from 'src/hooks/useAsyncProcesses';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import useNotifications from 'src/hooks/useNotifications';
import useTheme from 'src/hooks/useTheme';

//import PropTypes from 'prop-types';

dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);

const Notifications = () => {
  const { executeAsyncProcess } = useAsyncProcesses();
  const { setBreadcrumb, dropBreadcrumb } = useBreadcrumb();

  const notificationsHook = useNotifications();
  const { isDarkMode } = useTheme();

  const columns = [
    {
      title: 'Title',
      key: 'title',
      width: 250,
      render: (record) => <div style={{ color: record.is_read ? 'gray' : isDarkMode ? 'lightGray' : 'black' }}> {record.title}</div>,
    },
    {
      title: 'Description',
      key: 'description',
      width: 640,
      render: (record) => <div style={{ color: record.is_read ? 'gray' : isDarkMode ? 'lightGray' : 'black' }}>{translateDescription(record.description)}</div>,
    },
    {
      title: 'Created',
      key: 'created_at',
      align: 'center',
      width: 200,
      render: (record) => (
        <span style={{ color: record.is_read ? 'gray' : isDarkMode ? 'lightGray' : 'black' }}>
          {dayjs(record.created_at).fromNow()}
          <br />
          <span className='font-thin text-xs'>at {dayjs(record.created_at).format('LLL')}</span>
        </span>
      ),
    },
  ];

  const translateDescription = (description) => {
    try {
      const linkRegex = /<a href=(.*?)>(.*?)<\/a>/;
      const match = description.match(linkRegex);
      if (match) {
        const beforeMatch = description.substring(0, match.index);
        const afterMatch = description.substring(match.index + match[0].length);

        const extractedText = match[2];
        const extractedLink = match[1];

        return (
          <span>
            <span>{beforeMatch}</span>
            <a href={extractedLink} dangerouslySetInnerHTML={{ __html: extractedText }} />
            <span>{afterMatch}</span>
          </span>
        );
      }
    } catch (error) {
      console.error(error);
    }

    return description;
  };

  useEffect(() => {
    loadData();
    setBreadcrumb([
      {
        title: 'Notifications',
      },
    ]);

    return () => {
      dropBreadcrumb();
    };
  }, []);

  const loadData = async () => {
    await executeAsyncProcess(async () => {
      try {
        await notificationsHook.refreshMyDbNotifications();
      } catch (error) {
        console.error(error);
      }
    });
  };

  const markAllAsReadFunc = async () => {
    await executeAsyncProcess(async () => {
      try {
        await notificationsHook.markAllAsReadFunc();
      } catch (error) {
        console.error(error);
      }
    });
  };

  const deleteAllUserNotifications = async () => {
    await executeAsyncProcess(async () => {
      try {
        await notificationsHook.deleteAllUserNotificationsFunc();
      } catch (error) {
        console.error(error);
      }
    });
  };

  return (
    <>
      <TitleBar title='Notification Center'>
        <Popconfirm placement='left' title={'Are you sure to mark all as read?'} description={'Mark all as read?'} okText='Yes' cancelText='No' onConfirm={async () => await markAllAsReadFunc()}>
          <Button disabled={notificationsHook.dbNotifications.filter((x) => !x.is_read).length === 0} icon={<BellOutlined />}>
            Mark all as Read
          </Button>
        </Popconfirm>
        <Popconfirm placement='left' title={'Are you sure to delete all messages?'} description={'Delete all?'} okText='Yes' cancelText='No' onConfirm={async () => await deleteAllUserNotifications()}>
          <Button disabled={notificationsHook.dbNotifications.length === 0} className='ml-2' icon={<DeleteOutlined />}>
            Delete all
          </Button>
        </Popconfirm>
      </TitleBar>
      <div className='p-4'>
        <Table size='small' columns={columns} dataSource={notificationsHook.dbNotifications} rowKey={'id'} />
      </div>
    </>
  );
};

// TicketList.propTypes = {};

export default Notifications;
